<widget-card>
  <details-widget-title [count]="0" text="Manage my open expenses">
    <fa-icon slot="icon" fixedWidth="true" [icon]="['fas', 'coins']"></fa-icon>
  </details-widget-title>
  <h3>{{ this.state }}</h3>
</widget-card>
